import React from 'react';
import classnames from 'classnames';

import styles from './DashboardHeading.module.scss';

type DashboardHeadingLevel = 1 | 2 | 3;

interface DashboardHeadingProps {
  /** @string - Classname to be passed to the element */
  className?: string;
  /** @DashboardHeadingLevel - Heading importance level */
  level?: DashboardHeadingLevel;
}

const DashboardHeading: React.FC<DashboardHeadingProps> = ({ children, className, level }) => {
  return (
    <h3
      className={classnames(className, styles.heading, {
        [styles[`heading-${level}`]]: level,
      })}
    >
      {children}
    </h3>
  );
};

export default DashboardHeading;
